module.exports = __webpack_public_path__ + "img/settings.e0ddc344.svg";